import { BankAcquirerService } from "./../../../services/catalogs/BankAcquirerService";
import { CatalogService } from "./../../../services/catalogs/CatalogService";
import { BankAcquirerDetail } from "./../../../components/Pages/Catalogs/BankAcquirer/BankAcquirerDetail";
import { CreateBankAcquirerDto } from "./../../../dtos/catalogs/bankacquirer/CreateBankAcquirerDto";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupBankAcquirer } from "../../../components/Shared/NewForms/NFLookupBankAcquirer";
import BankAcquirerList from "../../../components/Pages/Catalogs/BankAcquirer/BankAcquirerList";

export const BankAcquirer: IAppEntity = {
  entityType: "catalog",
  title: "Bank Acquirer",
  pluralTitle: "BankAcquirers",
  apiUrl: "BankAcquirers",
  apiEnum: ReferenceTypes.CatalogBankAcquirer,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(BankAcquirerDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(BankAcquirerList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupBankAcquirer, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new BankAcquirerService(this.apiUrl);
  },
  getEmptyModel(): CreateBankAcquirerDto {
    return {
      name: "",
      companyId: "",
      bankAccountId: "",
      terminalNumber: "",
      acquirer: "",
    };
  },
};
